import { Box, Theme, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import { ReactComponent as MetricIcon } from '../../assets/icons/Metrics.svg';
import { ReactComponent as StandardIcon } from '../../assets/icons/Standard.svg';
import { ReactComponent as OtherConfigurationIcon } from '../../assets/icons/Configuration-50.svg';
import PanelMetrics from '../../components/configuration/metrics/PanelMetrics';
import { useSubscriptionContext } from '../../context/SubscriptionContext';
import AlertBanner from '../../components/shared/banner/AlertBanner';
import { ExceededQuotaKey } from '../../lib/app/subscription';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationMetrics = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Metrics', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  // Company subscription state.
  const { subscription, getExceededSubscriptionKeys } = useSubscriptionContext();
  const [showQuotaExceededAlert, setShowQuotaExceededAlert] = useState(false);

  const exceeded_subscription_keys: Array<ExceededQuotaKey> = getExceededSubscriptionKeys([
    'e_metrics',
    's_g_metrics'
  ]);

  // Close quota reached alert message.
  const handleClose = () => {
    setShowQuotaExceededAlert(false);
  };

  // Validate subscription quota.
  useEffect(() => {
    if (exceeded_subscription_keys.length) {
      setShowQuotaExceededAlert(true);
    }
  }, [subscription]);

  return (
    <Box>
      <ConfigurationWrapper
        title="Metrics"
        icon={<MetricIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/standards',
          label: 'Standards',
          icon: <StandardIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
        next={{
          route: '/configuration/other-configuration',
          label: 'Other Configuration',
          icon: <OtherConfigurationIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <AlertBanner
          severity="warning"
          message={`Quota reached for ${exceeded_subscription_keys
            .map((item) => `${item.label} (${subscription?.quota[item.key]})`)
            .join(', ')} allocated to your subscription.`}
          open={showQuotaExceededAlert && !!exceeded_subscription_keys.length}
          action={handleClose}
        />
        <PanelMetrics master_list={false} />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationMetrics;
